import '.f{position:fixed;}.ssr-plugin'
import '.b3{top:0px;}.ssr-plugin'
import '.ba{left:0px;}.ssr-plugin'
import '.bb{right:0px;}.ssr-plugin'
import '.bc{bottom:0px;}.ssr-plugin'
import '.bd{background-color:rgba(0, 0, 0, 0.25);}.ssr-plugin'
import '.be{z-index:998;}.ssr-plugin'
import '.bf{transition:opacity 0.3s ease;}.ssr-plugin'
import '.bg{height:100vh;}.ssr-plugin'
import '.l{width:100%;}.ssr-plugin'
import '.t{background-color:var(--palette-white);}.ssr-plugin'
import '.bh{transition:transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);}.ssr-plugin'
import '.bi{z-index:999;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.ao{justify-content:space-between;}.ssr-plugin'
import '.bj{padding:1.5rem;}.ssr-plugin'
import '.bk{border-bottom:var(--border-default);}.ssr-plugin'
import '.ac{flex-shrink:0;}.ssr-plugin'
import '.af{flex:1;}.ssr-plugin'
import '.bl{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { IconButton } from '@app/components/core/button/IconButton'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import { PropsWithChildren } from 'react'
import useMediaQuery from '@app/util/useMediaQuery'

export interface DrawerProps extends PropsWithChildren {
  title: string
  open: boolean
  setOpen: (open: boolean) => void
  portal?: HTMLElement
  style?: Style
  side: 'left' | 'right'
}

export const Drawer = ({
  title,
  open,
  setOpen,
  children,
  portal: _portal,
  style,
  side,
}: DrawerProps) => {
  const isMobile = useMediaQuery()

  const translateValue = open ? '0' : side === 'left' ? '-100%' : '100%'

  return (
    <>
      {/* Overlay */}
      <div className="f b3 ba bb bc bd be bf"
        onClick={() => setOpen(false)}
        style={{
          opacity: open ? 1 : 0,
          pointerEvents: open ? 'auto' : 'none',}}
      />

      {/* Sidebar Panel */}
      <styled.div className="f b3 bg l t bh bi a b"
        style={{
          [side]: 0,
          maxWidth: isMobile ? '100%' : '30rem',
          borderRadius: isMobile ? 0 : '1.25rem',
          boxShadow: open ? '0 0 15px rgba(0,0,0,0.15)' : 'none',
          transform: `translateX(${translateValue})`,
          ...style,
        }}
      >
        {/* Header */}
        <div className="a r ao bj bk ac"
        >
          <Title.H4 style={{ margin: 0 }}>{title}</Title.H4>
          <IconButton
            icon={faXmark}
            size="small"
            variant="secondary"
            onClick={() => setOpen(false)}
          />
        </div>

        {/* Content */}
        <div className="af bl bj"
        >
          {children}
        </div>
      </styled.div>
    </>
  )
}
